/* eslint-disable */
import React from 'react';
import {connectModalContainerContextToComponent} from '../../../../../contexts/ModalContext/ModalContext';
import ActionSummaryRow from "../../../../xlalerts/common/actions/ActionSummaryRow";
import {Card} from "react-bootstrap";
import {useSelector} from "react-redux";
import {selectUserList} from "../../../../../redux/slices/userListSlice/userListSlice";
import { selectSingleAlert } from '../../../../../redux/slices/singleAlertSlice/singleAlertSlice';

function AlertActionList() {

  const users = useSelector(selectUserList);
  const activeAlert = useSelector(selectSingleAlert);
  const { alertActionList } = activeAlert || [];

  return (
    <div
      style={{ display: 'flex', flexDirection: 'column' }}
      id="action-list"
    >

      <Card>
        <Card.Body>
          {alertActionList && alertActionList.length > 0 && alertActionList.map((action, index) => (
              <React.Fragment key={index}>
                <ActionSummaryRow action={action} usersList={users} />
                <hr />
              </React.Fragment>
          ))}
        </Card.Body>
      </Card>
    </div>
  );
}

export { AlertActionList };
export default connectModalContainerContextToComponent(AlertActionList);
